import {Component, OnInit} from '@angular/core';
import {FormControl, NgForm} from "@angular/forms";
import {ProductsService} from "../../shared/services/products.service";
import {GlobalService} from "../../shared/services/global.service";
import {debounceTime, map, tap} from "rxjs/operators";
import {Constantes} from "../../shared/constantes";
import {NotificationService} from "../../shared/services/notification.service";
import {Router} from "@angular/router";
@Component({
  selector: 'app-product-new',
  templateUrl: './product-new.component.html',
  styleUrls: ['./product-new.component.css']
})
export class ProductNewComponent implements OnInit {
  readonly Constantes = Constantes;
  existedProductLocalities: any = [];
  existedProductCountry: any;
  existedProductCity: any;
  ProductSubTypes: any = [];
  ProductPensions: any = [];
  localities: any = [];
  listOfCountry :any = [];
  listOfCityForCountry :any = [];
  checked = true;
  formControl = new FormControl();
  value = 'resolve';
  allowClear = true;
  required = true;
  disabled = false;
  newDetailName="";
  localityName = 'fra';
  parentCode = 'accommodation';
  isLoading = false;
  filteredLocalities: any;
  errorMsg: string = '';
  searchLocalityName =  new FormControl();
  addNew:boolean=false;
  constructor(
    private notification: NotificationService,
    private productService: ProductsService,
    private globalService: GlobalService,
    private router:Router) {}
  ngOnInit() {
    //this.getProductPensions();
    //this.getProductSubTypes();
    this.getlocalitiesByName();
    this.getCountry();
  }
  getCountry() {
    this.globalService.getCountry()
      .subscribe(
        Localities => { console.log('==> Country ==>  ',Localities);
          for (let countryItem in Localities[0]['data'])
          {
            if (Localities[0]['data'][countryItem]['type']['code']== 'country')
            {
              this.listOfCountry.push({'id':Localities[0]['data'][countryItem]['id'],'text':Localities[0]['data'][countryItem]['nameFr']+' ('+Localities[0]['data'][countryItem]['code']+')'});
            }
          }
        },
        error => {
          this.globalService.checkApiError(error);
        }
      );
  }
  getCityOfCountry(mainParentId:any)
  {
    this.globalService.getCityOfCountryByID(mainParentId)
      .subscribe(
        CityOfCountry => {  console.log('CityOfCountry ==> ',CityOfCountry);
          this.listOfCityForCountry=[];
          for (let cityItem in CityOfCountry[0]['data'])
          {
            if (CityOfCountry[0]['data'][cityItem]['type']['code']== 'city')
            {
              this.listOfCityForCountry.push({'id':CityOfCountry[0]['data'][cityItem]['id'],'text':CityOfCountry[0]['data'][cityItem]['nameFr']});
            }
          }
        },
        error => {
          this.globalService.checkApiError(error);
        }
      );
  }
  getProductPensions() {
    this.globalService.getParameterValue('', 'meal_plan_type')
      .subscribe(
        ProductPensions => {
          for (let item in ProductPensions[0]['data']) {
            this.ProductPensions.push(ProductPensions[0]['data'][item]);
          }
        },
        error => {
          this.globalService.checkApiError(error);
        }
      );
  }
  getProductSubTypes() {
    this.globalService.getParameterValue(this.parentCode, 'product_subtype')
      .subscribe(
        ProductSubTypes => {
          for (let item in ProductSubTypes[0]['data']) {
            this.ProductSubTypes.push(ProductSubTypes[0]['data'][item]);
          }
        },
        error => {
          this.globalService.checkApiError(error);
        }
      );
  }
  getlocalitiesByName() {
    this.searchLocalityName.valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {
          this.errorMsg = "";
          this.filteredLocalities = [];
          this.isLoading = true;
        }),
        map(localityNameFr => localityNameFr.toString().trim())
      )
      .subscribe((localityNameFr: string) => {
          this.globalService.getlocalitiesByName(localityNameFr).subscribe(
            searchResponse => {
              if (searchResponse[0] !== undefined) {
                this.isLoading = false;
                this.localities=searchResponse[0]['data'];
              }
            },
            error => {
              this.globalService.checkApiError(error);
            }
          )

        }
      );

  }
  localityDisplayFormat(locality: any): string {
    if (locality) {
      return locality.nameFr + ' [' + locality.code + ']';
    } else {
      return '';
    }
  }
  /* save locality on select*/
  localitiesOptionSelected(locality: any): boolean {
    let newCode='';
    /********* delete doublons if existe ***********/
    for (let item in this.existedProductLocalities)
    {
      if (this.existedProductLocalities[item]['code']==locality['code'])
      {
        this.existedProductLocalities.splice(item, 1);
      }
    }
    /********** save new locality on first element of  existedProductLocalities *********/
    this.existedProductLocalities.unshift(locality);
    newCode=locality['code'].toString().trim();
    /****** empty uatosuggest new locality **********/
    if (event && this.searchLocalityName) {
      let newLocalities: any = [];
      $(".autocompleteInput").val('');
    }
    /**************** set border color green  for new locality *********/
    setTimeout(function(){ $('#newLocalityBadge_'+newCode).parent().addClass('newAdd') }, 400);
    return true;
  }
  removeThisLocality(code: string) {

    for (let i in this.existedProductLocalities) {
      if (this.existedProductLocalities[i]['code'] == code) {
        this.existedProductLocalities.splice(i, 1);
        break;
      }
    }
  }
  onSubmit(form:NgForm)
  {
    if(form.valid)
    {
      this.globalService.showSpinner();
      let nameFr = form.value.name;
      nameFr=nameFr.trim();
      let code = form.value.code;
      let subTypeId=null;
      let pensionId=null;
      let tripAdvisorCode=form.value.tripAdvisorCode;
      let minAge=form.value.minAge;
      let longitude=form.value.longitude;
      let latitude=form.value.latitude;
      let URLVideo=form.value.URLVideo;
      let URLMap=form.value.URLMap;
      let countrys=form.value.countrys;
      let citys=form.value.citys;
      this.existedProductLocalities=[];
      this.existedProductLocalities.push({'id':countrys});
      this.existedProductLocalities.push({'id':citys});
      let typeId=localStorage.getItem('accommodation');
      let isActive =false;
      if ($("#product_active").prop('checked'))
      {
        isActive=true;
      }
      else
      {
        isActive=false;
      }
      if (typeId!=null)
      {
        console.log('existedProductLocalities =================> ',this.existedProductLocalities);
      this.productService.addEditProductGeneralities(nameFr,code,tripAdvisorCode,minAge,longitude,latitude,typeId,subTypeId,null,null,isActive,URLVideo,URLMap,this.existedProductLocalities,null,null,null)
        .subscribe(
          response => {
            this.globalService.hideSpinner();
            if (!isNaN(response['id']))
            {
              this.newDetailName=response['nameFr'];
              let router=this.router;
              this.notification.showSuccess("L'hôtel   '" +this.newDetailName+ "'   a été ajouté avec succès","");
              setTimeout(function()
              {
                $("html, body").animate({ scrollTop: 0 }, "slow");
              }, 2200);
              setTimeout(function()
              {
                router.navigateByUrl("/product/"+response['id']+"/"+response['code'])
              }, 2200);
            }
          },
          error => {
            this.globalService.hideSpinner();
            console.log('error ==>',error);
            this.notification.showError(error['error']['hydra:description'],"");
          }
        );
    }
    }

  }
  addNewLocalities()
  {
    this.addNew=true;
  }
  hideNewLocalities() {
    this.addNew=false;
  }
}
